export const createUsers = /* GraphQL */ `
  mutation CreateUsers(
    $input: CreateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    createUsers(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateUsers = /* GraphQL */ `
  mutation UpdateUsers(
    $input: UpdateUsersInput!
    $condition: ModelUsersConditionInput
  ) {
    updateUsers(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateCompaniesContactPersons = /* GraphQL */ `
  mutation UpdateCompaniesContactPersons(
    $input: UpdateCompaniesContactPersonsInput!
    $condition: ModelCompaniesContactPersonsConditionInput
  ) {
    updateCompaniesContactPersons(input: $input, condition: $condition) {
      id
    }
  }
`;

export const createCompaniesContactPersons = /* GraphQL */ `
  mutation CreateCompaniesContactPersons(
    $input: CreateCompaniesContactPersonsInput!
    $condition: ModelCompaniesContactPersonsConditionInput
  ) {
    createCompaniesContactPersons(input: $input, condition: $condition) {
      id
    }
  }
`;
